module.exports = "/_next/static/media/4745254f79521596266b26bed2949f7e.svg";